import React, { useMemo } from 'react';
import Accordion from '@mui/material/Accordion';
import { AccordionSummary } from "../theme/theme";
import AccordionDetails from "@mui/material/AccordionDetails";

const FeatureTable = ({
                          setFeatureLabel,
                          showAllFeature,
                          handleChange,
                          featuresLabel,
                          hasDisclaimer
                      }) => {

    const accordions = useMemo(() => {
        return Object.values(setFeatureLabel).map((featureValue) => {
            return (
                <div className="accordion-menu" key={`${featureValue.name}`} id={`${featureValue.name}`}>
                    <Accordion
                        expanded={!!featuresLabel?.includes(featureValue.name)}
                        id={featureValue.name}
                        onChange={handleChange(featureValue.name)}
                        elevation={0}
                    >
                        <AccordionSummary>
                            <div id={featureValue.name} data-value={featureValue.name}> {featureValue.name} </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <table className={'feature-table'}>
                                { showAllFeature(featureValue) }
                            </table>
                            <div className='feature-disclaimer'>
                                { featureValue.disclaimer && hasDisclaimer ? featureValue.disclaimer : null }
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
            )
        });
    }, [setFeatureLabel, showAllFeature, handleChange, featuresLabel]);

    return (
        <div id={"affixed-category-header"} className={'feature-panel-category'}>
            { accordions }
        </div>
    );
}

export default FeatureTable;